import { forwardRef } from 'react';
import { classes } from 'utils/style';
import styles from './Heading.module.css';

export const Heading = forwardRef(
  ({ children, level = 1, as, align = 'auto', weight = 'medium', className, ...rest }, ref) => {
    const clampedLevel = Math.min(Math.max(level, 0), 5);
    const Component = as || `h${Math.max(clampedLevel, 1)}`;

    return (
      <Component
        ref={ref}
        className={classes(styles.heading, className)}
        data-align={align}
        data-weight={weight}
        data-level={clampedLevel}
        {...rest}
      >
        {children}
      </Component>
    );
  }
);

Heading.displayName = 'Heading';
